<p-table [value]="questionnaireQuestions" #dt1 dataKey="id" [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    [globalFilterFields]="['name']" [paginator]="true" [rows]="15" [rowsPerPageOptions]="tableShowMore">
    <ng-template pTemplate="caption">
        <div class="table-header p-d-flex p-jc-between">
            <div>
                <p-toggleButton class="p-mb-2" onLabel="Active" offLabel="InActive" [onIcon]="'pi pi-check'"
                    [offIcon]="'pi pi-times'" iconPos="right" [(ngModel)]="isActiveForQuestion"
                    (onChange)="getQuestions()">
                </p-toggleButton>
            </div>
            <span class="p-input-icon-left">
                <i class="pi pi-search"></i>
                <input pInputText type="text" (input)="dt1.filterGlobal($event.target.value, 'contains')"
                    placeholder="Search Question" />
            </span>
        </div>
    </ng-template>
    <ng-template pTemplate="header">
        <tr>
            <th style="width: 3rem"></th>
            <th pSortableColumn="name">Question <p-sortIcon field="name"></p-sortIcon></th>
            <th style="width: 100px;">Is Active</th>
            <th style="width: 120px;">Action</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-product let-expanded="expanded">
        <tr>
            <td class="action">
                <button type="button" pButton pRipple [pRowToggler]="product"
                    class="p-button-text p-button-rounded p-button-plain"
                    [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                    *ngIf="product?.questionOptions?.length>0"></button>
            </td>
            <td>{{product.name}}</td>
            <td>{{product.statusId==1?'Yes':'No'}}</td>
            <td class="action">
                <span class="btnBars p-mr-0" (click)="showEditQuestion(product)" pTooltip="Edit"
                    tooltipPosition="top"><i class="pi pi-pencil"></i></span>
                <span class="btnBars p-mr-0" (click)="deleteQuestion(product)" pTooltip="Delete"
                    tooltipPosition="top"><i class="pi pi-trash"></i></span>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="rowexpansion" let-product>
        <tr>
            <td colspan="4" class="action">
                <p-table [value]="(product?.questionOptions||[])" dataKey="id">
                    <ng-template pTemplate="body" let-answer let-expanded="expanded">
                        <tr>
                            <td style="width: 3.5rem" class="action">
                                <ng-container *ngFor="let s of product.subQuestions">
                                    <button type="button" pButton pRipple [pRowToggler]="answer"
                                        *ngIf="s.questionOptionId == answer.id"
                                        class="p-button-text p-button-rounded p-button-plain"
                                        [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"></button>
                                </ng-container>
                            </td>
                            <td>{{answer.value}}</td>
                            <td style="width: 90px;"></td>
                            <td style="width: 110px;" class="action">
                                <span class="btnBars p-mr-0" *ngIf="checkSubQuestionAvailability(product,answer)"
                                    (click)="addQuestionnaireSubQuestion(product,answer)" pTooltip="Add" tooltipPosition="top">
                                    <i class="pi pi-plus"></i></span>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template pTemplate="rowexpansion" let-answer let-expanded="expanded">
                        <tr>
                            <td colspan="4" class="action">
                                <p-table [value]="product.subQuestions" dataKey="id">
                                    <ng-template pTemplate="body" let-sub let-expanded="expanded">
                                        <tr *ngIf="answer.id == sub.questionOptionId">
                                            <td class="action" style="width: 3.5rem">
                                                <button type="button" pButton pRipple [pRowToggler]="sub"
                                                    class="p-button-text p-button-rounded p-button-plain"
                                                    [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'"
                                                    *ngIf="sub?.questionOptions?.length>0"></button>
                                            </td>
                                            <td>{{sub.name}}</td>
                                            <td style="width: 80px;"></td>
                                            <td class="action" style="width: 100px;">
                                                <span class="btnBars p-mr-0" (click)="showEditSubQuestion(sub)" pTooltip="Edit" tooltipPosition="top">
                                                    <i class="pi pi-pencil"></i>
                                                </span>
                                                <span class="btnBars p-mr-0" (click)="deleteQuestion(sub)" pTooltip="Delete" tooltipPosition="top">
                                                    <i class="pi pi-trash"></i>
                                                </span>
                                            </td>
                                        </tr>
                                    </ng-template>
                                    <ng-template pTemplate="rowexpansion" let-sub let-expanded="expanded">
                                        <tr>
                                            <td colspan="4" class="action">
                                                <p-table [value]="(sub?.questionOptions||[])" dataKey="id">
                                                    <ng-template pTemplate="body" let-anss>
                                                        <tr>
                                                            <td style="width: 3.5rem;"></td>
                                                            <td>{{anss.value}}</td>
                                                        </tr>
                                                    </ng-template>
                                                </p-table>
                                            </td>
                                        </tr>
                                    </ng-template>
                                </p-table>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </td>
        </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
        <tr>
            <td colspan="7">No question found.</td>
        </tr>
    </ng-template>
</p-table>

<p-dialog [header]="addEditQuestionnaireHeader" [(visible)]="displayAddEditQuestions" [style]="{width: '50vw'}" [baseZIndex]="10000" [modal]="true" [closable]="true" (onHide)="cancelQuestionDialog()">
    <div class="header" style="margin-top:1px">
        <h5>Question Details
            <p-inputSwitch class="header-switch" [(ngModel)]="questionTemp.isValid" (onChange)="onIsValidChange()"></p-inputSwitch>
        </h5>
    </div>
    <form #questionForm="ngForm">
        <div style="width:100%" class="p-grid">
            <div class="p-col-12">
                <label for="name" class="p-mt-2">Question <span style="color: red;">*</span></label>
                <input type="text" pInputText [(ngModel)]="questionTemp.questionName" name="questionName" required>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-12">
                <label for="name" class="p-mt-2">Select Answer Type <span style="color: red;">*</span></label>
                <p-dropdown appendTo="body" [options]="answerTypes" name="answerTypes" [(ngModel)]="selectedAnswerType"
                    optionLabel="name" dataKey="id" placeholder="Select Answer Type" name="answerType" (onChange)="changeAnswerType()" required>
                </p-dropdown>
            </div>
        </div>
        <div class="p-grid" *ngIf="selectedAnswerType && !['Picture','Rating','InputBox','FileUpload'].includes(selectedAnswerType?.name)">
            <div class="p-col-12">
                <div class="p-mt-2"><span style="font-weight: bold;">Add {{selectedAnswerType ? selectedAnswerType.name : null}}</span>
                    <button *ngIf="(['ToggleButton'].includes(selectedAnswerType?.name) && questionTemp.questionPreDefinedInputAnswers?.length<2) || !['ToggleButton'].includes(selectedAnswerType?.name)" pButton icon="pi pi-plus" (click)="addFormControl()" style="float: right;"></button>
                    <button pButton icon="pi pi-minus" (click)="removeFormControl()" style="float: right;"
                        *ngIf="questionTemp.questionPreDefinedInputAnswers.length >= 1" class="p-mr-2">
                    </button>
                </div>
            </div>
        </div>
        <div class="p-grid">
            <div class="p-col-12">
                <div class="p-d-flex p-flex-column" *ngFor="let s of questionTemp.questionPreDefinedInputAnswers; let i=index">
                    <input type="text" class="p-mb-2" pInputText [(ngModel)]="s.preDefinedAnswerInput" name="answer{{i}}" required>
                </div>
            </div>
        </div>
    </form>
    <ng-template pTemplate="footer">
        <button pButton (click)="cancelQuestionDialog()" label="Cancel" class="p-button-secondary"></button>
        <button pButton (click)="saveEditQuestion(questionTemp)" [disabled]="questionForm.form.invalid || !questionTemp.questionName.trim()" label="Save"></button>
    </ng-template>
</p-dialog>
